export default function count(values, valueof) {
    var count = 0;
    if (valueof === undefined) {
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            if (value != null && (value = +value) >= value) {
                ++count;
            }
        }
    }
    else {
        var index = -1;
        for (var _a = 0, values_2 = values; _a < values_2.length; _a++) {
            var value = values_2[_a];
            if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
                ++count;
            }
        }
    }
    return count;
}
